function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import $ from 'jquery';
import uuidv1 from 'uuid/v1';
var WDHTabbedGroup = /*#__PURE__*/function () {
  function WDHTabbedGroup(tabs) {
    _classCallCheck(this, WDHTabbedGroup);
    /**
     * @private
     * @type {string}
     */
    this.wrapperClass = 'data-list-spot-tabbed-group';

    /**
     * @private
     * @type {Object} - collection of related data-hierarchy-list-search-spots
     */
    this.searchComponents = {};

    /**
     * @private
     * @type {jQuery} - jquery object pointing to the container wrapping our tab Group.
     */
    this.tabGroupWrapper = $("<div class=\"".concat(this.wrapperClass, "\">"));
    this.tabGroupWrapper.insertBefore(tabs[0][0]);

    /**
     * @private
     * @type {jQuery} - collection of jquery objects for each 'tab'
     */
    this.tabs = this.buildTabs(tabs);
  }

  /**
   * function to set our default options for the carousel
   * @param options {object}
   */
  return _createClass(WDHTabbedGroup, [{
    key: "setOptions",
    value: function setOptions(options) {
      if (_typeof(options) === 'object') {
        var tempOptions = Object.assign({}, this.options, options);
        this.options = tempOptions;
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.buildTabNavigation();
      var searchParams = new URLSearchParams(window.location.search); // can't use hash here as it is grabbed as the default value for the data-hierarchy search.
      var tab = searchParams.has('tab') ? searchParams.get('tab') : '';
      var tabLinks = $('.tab-links');
      var selectedTab;
      tabLinks.each(function (index, tablink) {
        var $tabLink = $(tablink);
        if ($tabLink.data('tabname') === tab) {
          selectedTab = $tabLink;
        }
      });
      if (selectedTab) {
        selectedTab.click();
      } else {
        $('.tab-links').first().click(); // select default tab
      }
    }
  }, {
    key: "buildTabs",
    value: function buildTabs(tabs) {
      var _this = this;
      var $tabs = null;
      tabs.forEach(function (elem, index) {
        var tabContent = $("<div class='tab-content'>");
        tabContent.data('tabTitle', elem.data('tabTitle'));
        tabContent.data('tabName', elem.data('tabName'));
        elem.each(function (index, el) {
          var $el = $(el);
          if ($el.data('configuration')) tabContent.data('configuration', $el.data('configuration'));
          tabContent.append(el);
        });
        _this.tabGroupWrapper.append(tabContent);
        if (!$tabs) {
          $tabs = tabContent;
        } else {
          $.merge($tabs, tabContent);
        }
      });
      return $tabs;
    }
  }, {
    key: "buildTabNavigation",
    value: function buildTabNavigation() {
      var _this2 = this;
      var tabContainer = $("<div class='tab-container'>");
      this.tabs.each(function (index, elem) {
        var $elem = $(elem);
        var tabId = uuidv1();
        var configID = $elem.data('configuration');
        _this2.searchComponents[tabId] = $(".data-list-search[data-endpoint*=".concat(configID, "]"));
        var tabTitle = $elem.data('tabTitle') ? $elem.data('tabTitle').trim() : "Tab ".concat(index + 1);
        var $tabButton = $("<button type=\"button\" class='tab-links' data-tabname=\"".concat($elem.data('tabName'), "\" data-tabid=\"").concat(tabId, "\">").concat(tabTitle, "</button>"));
        $tabButton.on('click', function (e) {
          _this2.showTab(e, tabId);
        });
        tabContainer.append($tabButton);
        $elem.addClass('tab-content');
        $elem.attr('id', tabId);
      });
      this.tabGroupWrapper.prepend(tabContainer);
    }
  }, {
    key: "showTab",
    value: function showTab(event, tabId) {
      event.preventDefault();
      this.tabs.css('display', 'none'); // hide all elements

      Object.entries(this.searchComponents).forEach(function (entry) {
        entry[1].css('display', 'none'); // hide all search boxes related to our tabs
      });
      $('.tab-links').removeClass('active'); // removes active button

      var currTab = document.getElementById(tabId);
      currTab.style.display = 'block';
      this.searchComponents[tabId].css('display', 'block');
      $(event.currentTarget).addClass('active');
    }
  }]);
}();
export default WDHTabbedGroup;